import { render, staticRenderFns } from "./fillingLogDetail.vue?vue&type=template&id=38a41504&scoped=true"
import script from "./fillingLogDetail.vue?vue&type=script&lang=js"
export * from "./fillingLogDetail.vue?vue&type=script&lang=js"
import style0 from "./fillingLogDetail.vue?vue&type=style&index=0&id=38a41504&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a41504",
  null
  
)

export default component.exports